



















































































import {
  defineComponent,
  ref,
  watch,
  toRef,
  onUnmounted,
  computed,
  getCurrentInstance,
  PropType,
} from "@vue/composition-api";
import { LiveChatUser } from "@scrile/api-provider/dist/api/LivechatsProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useOrientation from "@/hooks/useOrientation";
import providers from "@/lib/api";
import { parseISO, toTimePassed, differenceInMilliseconds } from "@/lib/time";
import { MediaConstraints } from "@/types";
import { connectionStateEnum } from "@/const";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseStreamVideo from "@/components/Base/BaseStreamVideo";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import BaseImage from "@/components/BaseImage/BaseImage";
import MobileSwitchCam from "@/components/MobileSwitchCam";
import Share from "@/components/Share";
import SwitchMicrophone from "@/components/SwitchMicrophone";
import StreamChat from "../StreamChat";
import ViewersList from "../ViewersList";

export default defineComponent({
  name: "StreamView",
  components: {
    BaseStreamVideo,
    SwitchMicrophone,
    ViewersList,
    BaseImage,
    BaseAvatar,
    BaseButton,
    BaseIcon,
    StreamChat,
    MobileSwitchCam,
    Share,
  },
  props: {
    produce: { type: Boolean, required: true },
    stream: { type: MediaStream, required: true },
    connecting: { type: Boolean, required: true },
    connectingState: { type: String, required: true },
    loading: { type: Boolean, required: true },
    userList: { type: Array as () => LiveChatUser[], required: true },
    streamStartedDate: { type: String, required: true },
    threadId: { type: String },
    token: { type: String },
    constraints: { type: Object as PropType<MediaConstraints> },
  },
  setup(props, { emit }) {
    const showTime = ref(true);
    const showEnding = ref(false);
    const showViewers = ref(false);
    const timePassed = ref("");
    const isStreamAlive = ref(false);
    const { isLandscape } = useOrientation();
    const produceUser = ref<UserPublicData | null>(null);
    const vm = getCurrentInstance();
    const getData = async () => {
      if (vm?.$route?.params.userId) {
        const { result } = await providers.UserPublicDataProvider.search({
          data: { id: [vm.$route.params.userId] },
        });
        produceUser.value = result[0] ?? null;
      }
    };

    getData();
    const timeClick = () => (showTime.value = !showTime.value);

    const overlayClass = computed(() => ({
      __background: showEnding.value || props.loading || props.connecting,
    }));

    const showChat = computed(() => !props.connecting && !props.loading && !!props.threadId && !!props.token);

    const mirrorVideo = computed(() => {
      const tracks = props.stream.getVideoTracks();
      const settings = tracks.length > 0 && props.stream.getVideoTracks()[0].getSettings();
      return props.produce && (!settings || !settings.facingMode || settings.facingMode === "user");
    });
    const onClose = () => emit("close");
    const endClick = () => {
      if (props.produce) {
        showEnding.value = !showEnding.value;
      } else {
        onClose();
      }
    };

    let interval: ReturnType<typeof setInterval>;
    watch(toRef(props, "streamStartedDate"), streamStartedDate => {
      interval && clearInterval(interval);
      if (!streamStartedDate) {
        timePassed.value = "";
        isStreamAlive.value = false;
        return;
      }
      isStreamAlive.value = true;
      const countDate = () => {
        timePassed.value = toTimePassed(
          Math.max(0, differenceInMilliseconds(new Date(), parseISO(props.streamStartedDate)))
        );
      };
      countDate();
      interval = setInterval(countDate, 1000);
    });

    const handleShowViewers = () => {
      if (!props.produce) return;
      showViewers.value = !showViewers.value;
    };

    onUnmounted(() => interval && clearInterval(interval));

    return {
      showTime,
      showEnding,
      showViewers,
      timePassed,
      isStreamAlive,
      produceUser,
      timeClick,
      endClick,
      onClose,
      handleShowViewers,
      overlayClass,
      showChat,
      isLandscape,
      mirrorVideo,
      connectionStateEnum,
    };
  },
});
